export { default } from './PaymentMethodsListNew';
